import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AbstractControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { Empresa, Usuario } from '../models';
import { environment } from 'src/environments/environment';
import { Email } from '../models/email.model';

@Injectable({
    providedIn: 'root'
})
export class RegistroService {

    // Observable  string source
    private telMovilSource = new Subject<string>();
    telMovil$ = this.telMovilSource.asObservable();
    regexCURP = '/^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/';
    regexRFC = '/^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/'



    constructor(
        private afs: AngularFirestore
    ) { }



    getErrorMessage(ev: AbstractControl) {
        // console.log('Control', ev, ev.errors);

        if (ev.hasError('required')) {
            return 'Debes ingresar un valor';
        }
        if (ev.hasError('pattern')) {
            return 'Parece que el contenido de este campo está incorrecto'
        }
        if (ev.hasError('minlength')) {
            return `El campo no cumple con la longitud mínima ${ev.errors['minlength'].requiredLength}`
        }
        if (ev.hasError('maxlength')) {
            return `El campo no cumple con la longitud máxima ${ev.errors['minlength'].requiredLength}`
        }
        return null;

    }


    cambiarTelefono(nuevoTel: string) {
        this.telMovilSource.next(nuevoTel);
    }

    async crearRegistroEmail(emailRecord: Email) {
        this.afs.collection('correos').add(emailRecord);
    }

    async confirmarEmail(uid: string) {
        this.afs.doc(`usuarios/${uid}`).update({ emailConfirmado: true });
    }

    crearHTML(nuevaEmpresa: Empresa, usuario: Usuario): string {

        let html = this.body(nuevaEmpresa, usuario);
        return html;
    }



    body(ne: Empresa, usuario: Usuario): string {
        return `
        <p>
        ${usuario.nombre} ${usuario.apellidoPaterno}, su información
        fue recibida
      </p>
      <p>
        <ul>
          <li><strong>Empresa:</strong> ${ne.alias}</li>
          <li><strong>Numero para Iniciar Sesión:</strong> ${ne.repTelMovil}</li>
          <li><strong>RFC:</strong> ${ne.empRFC}</li>
          <li><strong>Domicilio:</strong> ${ne.domCalle} ${ne.domNumeroExterior} ${ne.domNumeroInterior}, Colonia ${ne.domColonia} </br>
            ${ne.domMunicipio}, ${ne.domEstado} CP: ${ne.domCodigoPostal}</li>
        </ul>
      </p>

      <p style="padding-bottom: 20px">
        Por favor, valide su dirección de correo electrónico
      </p>
      <p style="text-align: center">
        <a href="${environment.appURL}/registro/confirmacion?token=${usuario.id}" class="button">Validar Email</a>
      </p>
    `;

    }


}
